// extracted by mini-css-extract-plugin
module.exports = {"Button":"button_Button__2S7nA","ButtonForm":"button_ButtonForm__1eEu4"};